import Privacy from "./privacy"

const Datenschutz = () => {
  return <Privacy />
}
export default Datenschutz
